<template>
  <form @submit.prevent="submit" >
    <div class="mb-3 mx-2">
      <label for="className" class="bmd-label-float">{{ $t('classes.form.name') }}</label>
      <input
        type="text"
        class="form-control borderless-input"
        :class="{ 'is-invalid': errors.name }"
        id="className"
        v-model="formData.name"
        :dir="locale === 'ar' ? 'rtl' : 'ltr'"
    
        required
      />
      <div class="invalid-feedback" v-if="errors.name">
        {{ errors.name[0] }}
      </div>
    </div>
  </form>
</template>

<script setup>
import { ref, watch, defineExpose, defineProps, defineEmits } from "vue";
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  initialData: {
    type: Object,
    default: () => ({ 
      name: '', 
    }),
  },
  isEdit: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["submit", "cancel", "validation-error",  "update:form-data"]);

const formData = ref({ ...props.initialData });
const errors = ref({});

watch(formData, (newVal) => {
  emit('update:form-data', newVal);
}, { deep: true });

watch(
  () => props.initialData,
  (newData) => {
    formData.value = { ...newData };
    emit('update:form-data', formData.value);
  },
  { deep: true, immediate: true }
);

const validateForm = () => {
  let isValid = true;
  errors.value = {};

  if (!formData.value.name?.trim()) {
    errors.value.name = [t('classes.form.nameRequired')];
    isValid = false;
  }

  if (!isValid) {
    emit("validation-error");
  }

  return isValid;
};

const submit = () => {
  if (validateForm()) {
    emit("submit", formData.value);
  }
};

const setServerErrors = (serverErrors) => {
  errors.value = { ...serverErrors };
};

defineExpose({
  submit,
  setServerErrors,
  validateForm
});
</script>